import { useEffect } from 'react';
import './Jobs.scss';
import JobsTable from 'componentsV2/Jobs/JobsTable';

const Jobs = () => {
  
  useEffect(() => {
    document.title = 'Jobs';
  }, []);
  
  return (
    <div className="jobs-page" data-testid="jobs-page">
      <JobsTable />
    </div>
  );
};

export default Jobs;
